import { BehaviorSubject } from 'rxjs';

import { inject, Injectable } from '@angular/core';
import { IOrganisationAndOrganisationUser } from '@organisations/models/organisation-user';
import { AnalyticsService } from '@shared/services/analytics/analytics.service';

@Injectable({
	providedIn: 'root',
})
export class OrganisationSelectedService {
	selectedOrganisation: BehaviorSubject<IOrganisationAndOrganisationUser | null>;

	private analyticsService = inject(AnalyticsService);

	constructor() {
		this.selectedOrganisation = new BehaviorSubject<IOrganisationAndOrganisationUser | null>(null);
	}

	setSelectedOrganisation(availableOrganisation: IOrganisationAndOrganisationUser | null): void {
		this.selectedOrganisation.next(availableOrganisation);
		localStorage.setItem('selectedOrganisationId', availableOrganisation?.organisationUser.organisation.id as string);

		this.analyticsService.setOrganiationId(availableOrganisation?.organisationUser.organisation.id as string);
	}

	getSelectedOrganisationId(): string | null {
		return localStorage.getItem('selectedOrganisationId');
	}

	clearSelectedOrganisation(): void {
		this.selectedOrganisation.next(null);
	}
}
